import { render, staticRenderFns } from "./DropdownV2.vue?vue&type=template&id=4a85ed67&"
import script from "./DropdownV2.vue?vue&type=script&lang=js&"
export * from "./DropdownV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports